{
  "unvan": {
    "Ünvanlar": "Titel Definities",
    "Unvan Adı": "Titel Naam",
    "Sıra": "Volgorde",
    "Komisyon Türü": "Commissie Type",
    "Durum": "Status",
    "Aktif": "Actief",
    "Pasif": "Passief",
    "Tümü": "Alle",
    "Yeni Ekle": "Nieuw Toevoegen",
    "Ekle": "Toevoegen",
    "Güncelle": "Bijwerken",
    "Kaydet": "Opslaan",
    "İptal": "Annuleren",
    "Sil": "Verwijderen",
    "Filtrele": "Filteren",
    "Ara": "Zoeken",
    "Temizle": "Wissen",
    "Arama_Placeholder": "Zoeken...",
    "Yenile": "Vernieuwen",
    "İşlemler": "Acties",
    "Data Yenile": "Gegevens Vernieuwen",
    "Kapat": "Sluiten",
    "Düzeltme": "Bewerken",
    "Ad_Placeholder": "Bijv: Manager, Specialist etc.",
    "Sira_Placeholder": "Bijv: 10"
  }
}
